/**
 * 
 */
 class WMUPassword extends EventTarget {

    /**
     * 
     */
    constructor( element, args = {} )
    {
        super();

        this.inputElement = element;
        this.readableToggleElement = null;
        this.wrapperElement = null;

        this.args = {
            init: true,
            isReadable: false,
            makeItReadableLabel: 'Voir le contenu',
            makeItUnreadableLabel: 'Masquer le contenu',
            ...args
        };
        
        this.isInit = false;
        this.isReadable = this.args.isReadable;

        if ( true === this.args.init )
        {
            this.init();
        }
    }

    /**
     * Initialize the password enhancement
     * 
     * @returns void
     */
    init()
    {
        if ( this.inputElement && 'input' === this.inputElement.nodeName.toLowerCase() && 'password' === this.inputElement.getAttribute( 'type' ).toLowerCase() )
        {
            this.render();
            this.updateReadableStatus();
            this.initBehaviors();
            this.isInit = true;
        }
        else
        {
            console.log( "No input[type='password'] element or invalid one." );
        }
    }

    /**
     * 
     */
    render()
    {
        this.wrapperElement = document.createElement( 'div' );
        this.wrapperElement.classList.add( 'wmu-password-wrapper' );
        this.inputElement.after( this.wrapperElement );
        this.wrapperElement.appendChild( this.inputElement );

        this.readableToggleElement = document.createElement( 'div' );
        this.readableToggleElement.classList.add( 'wmu-password-readable-toggle' );
        this.inputElement.after( this.readableToggleElement );
    }

    /**
     * 
     */
    initBehaviors()
    {
        this.onToggleReadable = this.onToggleReadable.bind( this );

        this.readableToggleElement.addEventListener( 'click', this.onToggleReadable );
    }

    /**
     * 
     */
    updateReadableStatus()
    {
        if ( true === this.isReadable )
        {
            this.inputElement.setAttribute( 'type', 'text' );
            this.readableToggleElement.setAttribute( 'aria-label', this.args.makeItUnreadableLabel );
            this.readableToggleElement.innerHTML = "<span class='screen-reader'>" + this.args.makeItUnreadableLabel + "<span>";
            this.wrapperElement.classList.add( 'is-readable' );
        }
        else
        {
            this.inputElement.setAttribute( 'type', 'password' );
            this.readableToggleElement.setAttribute( 'aria-label', this.args.makeItReadableLabel );
            this.readableToggleElement.innerHTML = "<span class='screen-reader'>" + this.args.makeItReadableLabel + "<span>";
            this.wrapperElement.classList.remove( 'is-readable' );
        }
    }

    /**
     * 
     */
    setReadable( isReadable )
    {
        this.isReadable = isReadable;
        this.updateReadableStatus();
    }

    /**
     * 
     */
    toggleReadable()
    {
        this.setReadable( ! this.isReadable );
    }

    /**
     * 
     */
    onToggleReadable( event )
    {
        this.toggleReadable();
    }

}

export default WMUPassword;